import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { PreferencesComponent } from './preferences.component';
import { PersonalInfoComponent } from './personal-info/personal-info.component';
import { ContactInfoComponent } from './contact-info/contact-info.component';
import { PersonalPhotoComponent } from './personal-photo/personal-photo.component';
import { TokenService } from '../shared/token.service';
import { ProfileAvatarModule } from '../components/profile-avatar/profile-avatar.component';

@NgModule({
  imports: [CommonModule, SharedModule, ProfileAvatarModule],
  declarations: [PreferencesComponent, PersonalInfoComponent, ContactInfoComponent, PersonalPhotoComponent],
  providers: [TokenService],
})
export class PreferencesModule {}



// WEBPACK FOOTER //
// ./ts/app/preferences/preferences.module.ts